document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector("form.shopify-product-form");

  if (productForm) registerProductForm(productForm);

  function registerProductForm(form) {
    const section = form.closest(".Section");
    const options = form.querySelectorAll("select");
    const quantityInput = form.querySelector("input[name='quantity']");
    let maxQuantity = parseInt(
      form.querySelector(".variant-input").dataset.inventory
    );
    maxQuantity = maxQuantity < 0 ? 0 : maxQuantity;
    const available =
      form.querySelector(".variant-input").dataset.track == "true";
    const price = form.querySelector(".Price");
    const sku = form.querySelector(".SKU");

    if (!quantityInput) return;

    let quantity = quantityInput.value || 1;

    if (maxQuantity == 0 && available) {
    } else {
      if (quantity > maxQuantity) {
        quantityInput.value = maxQuantity;
        quantity = maxQuantity;
      }

      quantityInput.addEventListener("change", function () {
        quantity = quantityInput.value;

        if (quantity > maxQuantity) {
          quantityInput.value = maxQuantity;
          quantity = maxQuantity;
        }

        if (quantity < 1) {
          return;
        }

        price.textContent = `$${((quantity * price.dataset.base) / 100).toFixed(
          2
        )}`;
      });
    }

    options.forEach((option) => {
      option.addEventListener("change", onVariantChange);
    });

    function onVariantChange(e) {
      const target = e.target.options[e.target.selectedIndex];
      const sectionId = section.dataset.sectionId;
      const newUrl =
        sectionId == "quick-view"
          ? target.dataset.oldProductUrl
          : target.dataset.productUrl;
      const newVariantId = target.dataset.variantId;

      let params = `section_id=${sectionId}&`;
      if (newVariantId) {
        // If the option value has a variant selection, call the section rendering api for that variant
        params += `variant=${newVariantId}`;
      } else {
        // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
        const selectedOptionValues = Array.from(
          form.querySelectorAll("option[selected]")
        )
          .map((element) => element.dataset.optionValueId)
          .join(",");
        params += `option_values=${selectedOptionValues}`;
      }

      // Section Rendering API
      fetch(`${newUrl}?${params}`)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newForm = doc.querySelector("form.shopify-product-form");

          newForm.querySelector("input[name='quantity']").value = quantity;
          const newPrice = newForm.querySelector(".Price");
          newPrice.textContent = `$${(
            (quantity * newPrice.dataset.base) /
            100
          ).toFixed(2)}`;

          form.replaceWith(newForm);
          publish(PUB_SUB_EVENTS.contentAdded, { content: newForm });
        });
    }
  }

  subscribe(PUB_SUB_EVENTS.contentAdded, function (data) {
    const productForm = data.content.matches("form.shopify-product-form")
      ? data.content
      : data.content.querySelector("form.shopify-product-form");
    if (productForm) registerProductForm(productForm);
  });
});
